import { render } from "./InternalPageField.vue?vue&type=template&id=794dca8e"
import script from "./InternalPageField.vue?vue&type=script&lang=js"
export * from "./InternalPageField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__